<template>
<div class="wrapper">
    <img :src="imgsrc" alt="">
</div>
  
</template>

<script>
export default {
    name: "dwgw",
    props:["imgsrc"]
}
</script>

<style scoped>
    /* 固定图片的宽高比例 在网络延迟大的情况下固定图片的宽高比 */
    .wrapper{
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-bottom: 37.89%;
        background-color: #eee;
    }
    img{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/dwgwcontenheader.vue